import React from "react";
import * as moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { municipalities } from "../../../../../resources/location-codes.json";
import {
  changeListsModal,
  setActiveListDisplay,
  setActiveListId,
  appendDeletionArray,
  subtractDeletionArray,
} from "../../../../../redux/actions/lists";
import {
  ChangeIconButton,
  DeleteIconButton,
  InfoTableButton,
} from "../../../../library/button";
import { Checkbox } from "../../../../library/checkbox";

const Index = ({ singleList, index, arr }) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const activeCompany = useSelector(
    (state) => state.activeCompany && state.activeCompany.activeCompany
  );
  const deletions = useSelector((state) => state.lists.deletionArray);

  const formatSizeNumber = (number) => {
    const value = number;
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  };

  const displayListArea = (area) => {
    const areas = area.split(",");
    if (areas && areas.length > 1) {
      var areaDisplay = [];
      for (var area in areas) {
        var singleArea = municipalities?.find(
          (item) => item.code === areas[area]
        );
        if (singleArea && singleArea?.title) {
          areaDisplay.push(singleArea.title);
        }
      }

      var areaExcerpt =
        areaDisplay.toString().length > 20
          ? areaDisplay.toString().substring(0, 20) + ".."
          : areaDisplay.toString();
      return { excerpt: areaExcerpt, fullInfo: areaDisplay.toString() };
    } else {
      const singleArea = municipalities.find((item) => item.code === areas[0]);
      return { excerpt: singleArea.title, fullInfo: singleArea.title };
    }
  };

  const determineEditButtonHover = () => {
    if (!activeCompany) {
      return "Du må velge et selskap før du kan utføre denne handlingen.";
    }

    if (activeCompany && !activeCompany.subscription) {
      return "Du må ha et aktivt abonnement for å kunne gjøre dette.";
    }
  };

  const handleSingleSelection = (e, id) => {
    if (e.target.checked) {
      if (!deletions.includes(id)) {
        dispatch(appendDeletionArray(id));
      }
    } else {
      if (deletions.includes(id)) {
        dispatch(subtractDeletionArray(id));
      }
    }
  };

  const clickDeleteSingleList = (key) => {
    if (activeCompany.subscription) {
      dispatch(changeListsModal({ deleteModal: true }));
      dispatch(setActiveListId({ id: key }));
    }
  };

  const determineDeleteButtonHover = () => {
    if (!activeCompany) {
      return "Du må velge et selskap før du kan utføre denne handlingen.";
    }

    if (activeCompany && !activeCompany?.subscription) {
      return "Du må ha et aktivt abonnement for å kunne gjøre dette.";
    }
  };

  const clickUpdateSingleList = (name, key) => {
    if (activeCompany?.subscription) {
      dispatch(changeListsModal({ editModal: true }));
      dispatch(setActiveListDisplay({ id: key, name: name }));
    }
  };

  const determineTitleHover = () => {
    if (!activeCompany) {
      return "Du må velge et selskap før du kan utføre denne handlingen.";
    }

    if (activeCompany && !activeCompany.subscription) {
      return "Du må ha et aktivt abonnement for å kunne gjøre dette.";
    }
  };

  const handleNavigation = (id) => {
    history.push(`/dashboard/liste/${id}`);
  };

  return (
    <tr key={singleList?.key} className={index === arr.length - 1 && "last"}>
      <td>
        <Checkbox
          onChange={(e) => handleSingleSelection(e, singleList?.key)}
          checked={deletions.includes(singleList?.key) ? true : false}
          type="checkbox"
          name="listId"
          type="checkbox"
          id="select"
        />
      </td>
      <td onClick={() => handleNavigation(singleList?.key)}>
        <span className="list-title">{singleList?.name}</span>
      </td>
      <td onClick={() => handleNavigation(singleList?.key)}>
        {moment.unix(singleList?.timestamp).format("HH:MM DD/MM/YYYY")}
      </td>
      <td onClick={() => handleNavigation(singleList?.key)}>
        <span>
          {singleList && singleList?.area && displayListArea(singleList?.area)
            ? displayListArea(singleList?.area).excerpt
            : "Ikke oppgitt"}
        </span>
      </td>
      <td>
        <InfoTableButton
          color="blue"
          title={singleList?.size ? formatSizeNumber(singleList.size) : "0"}
        />
      </td>
      <td>
        <ChangeIconButton
          data-tip={determineEditButtonHover()}
          onClick={() =>
            clickUpdateSingleList(singleList?.name, singleList?.key)
          }
        />
        <DeleteIconButton
          data-tip={determineDeleteButtonHover()}
          onClick={() => clickDeleteSingleList(singleList?.key)}
        />
      </td>
    </tr>
  );
};

export default Index;
